import { render } from "./Header.vue?vue&type=template&id=612bc217&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=612bc217&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612bc217"]])

export default __exports__